import * as yup from "yup";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import { normalizeTextField } from "utils/helpers/validations";
import {
  attachAcorisForeignCountryTest,
  isAcorisZipCode,
} from "../utils/zipCode";

const validation = (errors) => {
  const requiredString = yup
    .string()
    .transform(normalizeTextField)
    .typeError(errors.REQUIRED)
    .required(errors.REQUIRED);
  const optionalTextField = yup
    .string()
    .transform(normalizeTextField)
    .typeError(errors.NOT_STRING)
    .nullable();

  return yup.object().shape({
    telecoms: attachAcorisForeignCountryTest(
      yup.object().shape({
        [CONTACT_POINT_SYSTEM.CITY]: yup.object().shape({
          value: requiredString,
        }),
        [CONTACT_POINT_SYSTEM.ADDRESS]: yup.object().shape({
          value: requiredString,
        }),
        [CONTACT_POINT_SYSTEM.ADDRESS_LOCATION]: yup.object().shape({
          value: optionalTextField,
        }),
        [CONTACT_POINT_SYSTEM.COMPLEMENT]: yup.object().shape({
          value: optionalTextField,
        }),
        [CONTACT_POINT_SYSTEM.RESIDENCE]: yup.object().shape({
          value: optionalTextField,
        }),
        [CONTACT_POINT_SYSTEM.ZIP_CODE]: yup.object().shape({
          value: yup
            .string()
            .typeError(errors.REQUIRED)
            .required(errors.REQUIRED)
            .test("isValid", errors.INVALID_VALUE, function (value) {
              return isAcorisZipCode(value);
            }),
        }),
        [CONTACT_POINT_SYSTEM.COUNTRY]: yup.object().shape({
          value: optionalTextField,
        }),
      }),
      errors.REQUIRED,
    ),
  });
};

export default validation;
